__turbopack_context__.v({
  "actions": "CalcIntro-module-scss-module__8FhGDa__actions",
  "content": "CalcIntro-module-scss-module__8FhGDa__content",
  "description": "CalcIntro-module-scss-module__8FhGDa__description",
  "image": "CalcIntro-module-scss-module__8FhGDa__image",
  "notes": "CalcIntro-module-scss-module__8FhGDa__notes",
  "title": "CalcIntro-module-scss-module__8FhGDa__title",
});
